import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import { DoneAll } from "@mui/icons-material";
import { useState } from "react";
import { useUpdateRecords } from "../../api/useUpdateRecords";

type NotificationItem = {
    id: string;
    is_read: boolean;
    item: Array<{ item: unknown }>;
};

type MarkAllNotificationsReadProps = {
    notifications: Array<NotificationItem>;
    notificationsCount: number;
};

export const MarkAllNotificationsRead = ({ notifications, notificationsCount }: MarkAllNotificationsReadProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const updateRecords = useUpdateRecords({ queryInvalidatePrefix: "notifications" });

    const handleMarkAllAsRead = async () => {
        const unreadNotifications = notifications.filter((item) => {
            const hasValidItem = item.item[0]?.item !== null;
            const isUnread = !item.is_read;
            return hasValidItem && isUnread;
        });

        const updateData = unreadNotifications.map((n) => ({ id: n.id, is_read: true }));

        await updateRecords.mutateAsync({
            entity: "notifications",
            data: updateData,
        });

        setIsDialogOpen(false);
    };

    if (notificationsCount === 0) {
        return null;
    }

    return (
        <>
            <Box
                onClick={() => setIsDialogOpen(true)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    cursor: "pointer",
                    opacity: 0.8,
                    transition: "opacity 0.2s",
                    "&:hover": { opacity: 1 },
                }}
            >
                <DoneAll sx={{ fontSize: 18 }} />
                <Typography variant="caption" sx={{ fontSize: "0.75rem" }}>
                    Marcar lidas
                </Typography>
            </Box>

            <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                <DialogTitle>Marcar todas como lidas</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tem a certeza que deseja marcar todas as {notificationsCount} notificações como lidas?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDialogOpen(false)} color="inherit">
                        Não
                    </Button>
                    <Button onClick={handleMarkAllAsRead} variant="contained" color="primary">
                        Sim
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

